
import { i18n } from 'fishx';
import cloneDeep from 'lodash/cloneDeep';
import isEmpty from 'lodash/isEmpty';
// import get from 'lodash/get';
import { qryCertType, qryCustList, qryServiceType, qrySubsList, qryLoginStaffInfo, qryLoginOrgInfo, frBpayStateCheck, qryServiceTypeByFr } from '@/services/search';
import { getRequestData, failAlert } from '@/utils';

export const defaultSearchModel = {
  certTypeList: [], // 证件类型列表
  customerList: [], // 根据用户名模糊查询出来对用户列表
  serviceTypeListObj: {}, // 服务类型列表
};

export default {
  namespace: 'search',
  state: cloneDeep(defaultSearchModel),
  effects: {
    *fetchLoginInfo({ payload }, { call, put, select }) {
      const { currentUser, currentUser: { userCode } } = yield select(state => state.dxpGlobal);
      const staffInfoData = yield call(qryLoginStaffInfo, { staffCode: userCode });
      const orgInfoData = yield call(qryLoginOrgInfo, { staffCode: userCode });
      const staffInfo = getRequestData(staffInfoData, false);
      const orgInfo = getRequestData(orgInfoData, false);
      currentUser.staffInfo = staffInfo;
      currentUser.orgInfo = orgInfo;
      yield put({
        type: 'dxpGlobal/save',
        payload: {
          currentUser,
        },
      });
      if (payload.from === 'Login') {
        // 如果来自登陆，需校验BPAY自注册状态
        const data = yield call(frBpayStateCheck, { orgId: Number(orgInfo.orgId) });
        const checkInfo = getRequestData(data, false);
        if (`${checkInfo.frBpayState}` === '0') {
          // 0：未注册 1：已注册 2：注册中
          failAlert({
            title: i18n('SEARCH_REGISTRATION_FIRST'),
            content: '',
            btnText: i18n('COMMON_OK'),
            callbackFunc: () => Fishx.history.push('SalesChannelMainViewBSNL'),
          });
        }
      }
    },

    *qryCertType(_, { call, put }) {
      const data = yield call(qryCertType);
      const { certTypeList = [] } = getRequestData(data, false);
      yield put({
        type: 'save',
        payload: {
          certTypeList,
        },
      });
    },

    *qryCustList({ payload }, { call, put }) {
      const { params } = payload;
      const data = yield call(qryCustList, params);
      const { custDtoList: customerList = [] } = getRequestData(data, false);
      yield put({
        type: 'save',
        payload: {
          customerList: customerList || [],
        },
      });
      return customerList;
    },

    *qryCust({ payload }, { call }) {
      const { params } = payload;
      const data = yield call(qryCustList, params);
      const { custDtoList: customerList = [] } = getRequestData(data, false);
      if (!isEmpty(customerList)) {
        return customerList[0];
      }
      return false;
    },

    *qryServiceType({ payload }, { call, put, select }) {
      const { serviceTypeListObj } = yield select(state => state.search);
      const { params } = payload;
      const data = yield call(qryServiceType, params);
      const { serviceTypeDtoList: serviceTypeList = [] } = getRequestData(data, false);
      serviceTypeListObj[params.dealerEventCode] = serviceTypeList;
      yield put({
        type: 'save',
        payload: {
          serviceTypeListObj,
        },
      });
    },

    *qryServiceTypeByFr({ payload }, { call, put, select }) {
      const { serviceTypeListObj } = yield select(state => state.search);
      const { params } = payload;
      const data = yield call(qryServiceTypeByFr, params);
      const { serviceTypeDtoList: serviceTypeList = [] } = getRequestData(data, false);
      serviceTypeListObj[params.dealerEventCode] = serviceTypeList;
      yield put({
        type: 'save',
        payload: {
          serviceTypeListObj,
        },
      });
    },

    *qrySubsList({ payload }, { call }) {
      const data = yield call(qrySubsList, payload);
      const { subsDtoList } = getRequestData(data) || {};
      return subsDtoList || [];
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
